import React from 'react'
import Layout from '../Layout'
import PreferenceForm from '../../../utils/CommonFunctionality/PreferenceFunction'
import DashboardHeader from '../DashboardHeader'
import { Container } from '@material-ui/core'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Preference = (props) => {
    return (
        <>
            <SEOTAG page="Preference" />
            <Layout props={props}>
                <div className="GFdashWrapperContainer">
                    <DashboardHeader />
                    <Container className="db-bids-wrapper mt-4 lq-db-table">
                        <h2 className="mp-head">NOTIFICATION PREFERENCES</h2>
                        <PreferenceForm props={props} />
                    </Container>
                </div>
            </Layout>
        </>
    )
}

export default Preference
